import moment from 'moment';

const getHour = (time) => {
  const hours = time.hour();
  return (hours <= 9 && `0${hours}`) || hours;
};

const getMinutes = (time) => {
  const minutes = time.minutes();
  return (minutes <= 9 && `0${minutes}`) || minutes;
};

const getHourAndMinutes = (time) => {
  const momentObject = moment(time);
  const hour = getHour(momentObject);
  const minutes = getMinutes(momentObject);

  return `${hour}:${minutes}`;
};

const formatIncompleteHour = (time) => {
  return (
    (time.length === 1 && `0${time}:00`) ||
    (time.length === 3 && `${time}00`) ||
    (time.length === 4 && `${time}0`) ||
    (time.length === 5 && time)
  );
};

const checkIfRealHour = (time) => {
  const hourAndMinutes = time.split(':');

  return hourAndMinutes[0] < 24 && hourAndMinutes[1] < 60;
};

export { getHourAndMinutes, formatIncompleteHour, checkIfRealHour };
